var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderOrderpurchaseorder',{attrs:{"img_header":_vm.header_image,"header":"รายละเอียดใบสั่งของ (Purchase order information)","link_back":"orderpuchaseordercompany"}}),_c('Detail_purchase_company')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }